class NSSDrawer extends HTMLElement {
  constructor() {
    super();

    this.debug = false;

    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Drawer] Connected:", this.drawerId);

    this.addEventListener(`click`, this.handleClick.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener(`keydown`, this.handleKeydown);
  }

  get drawerId() {
    return this.getAttribute(`nss-drawer-id`);
  }

  get portalEnabled() {
    return this.hasAttribute(`nss-portal`);
  }

  portalToBody() {
    if (this.parentElement === document.body) return;
    this._homeParent = this.parentElement;
    this._homeNext = this.nextSibling;
    document.body.appendChild(this);
  }

  restoreHome() {
    if (this.parentElement !== document.body) return;
    if (this._homeParent && this._homeParent.isConnected) {
      this._homeParent.insertBefore(this, this._homeNext);
    } else {
      this.remove();
    }
    this._homeParent = null;
    this._homeNext = null;
  }

  restoreHomeAfterTransition() {
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      this.removeEventListener(`transitionend`, finish);
      this.restoreHome();
    };
    this.addEventListener(`transitionend`, finish);
    setTimeout(finish, 400);
  }

  get isOpen() {
    return this.classList.contains(`nss-open`);
  }

  getVisibleVideo() {
    const videos = this.querySelectorAll(`.nss-drawer__video video`);
    for (const videoEl of videos) {
      if (videoEl.offsetParent !== null) return videoEl;
    }
    return videos[0] || null;
  }

  open() {
    if (this.isOpen) return;
    if (this.debug) console.log(`[NSS][Drawer] Opening:`, this.drawerId);

    if (this.portalEnabled) this.portalToBody();

    const activate = () => {
      this.classList.add(`nss-open`);
      document.body.classList.add(`nss-no-scroll`);
      document.addEventListener(`keydown`, this.handleKeydown);

      const panelEl = this.querySelector(`.nss-drawer__panel`);
      if (panelEl) panelEl.focus({ preventScroll: true });

      const videoEl = this.getVisibleVideo();
      if (videoEl) {
        const played = videoEl.play();
        if (played && played.catch) played.catch(() => {});
      }
    };

    if (this.portalEnabled) requestAnimationFrame(activate);
    else activate();
  }

  close() {
    if (!this.isOpen) return;
    if (this.debug) console.log(`[NSS][Drawer] Closing:`, this.drawerId);

    this.classList.remove(`nss-open`);
    document.removeEventListener(`keydown`, this.handleKeydown);

    const videos = this.querySelectorAll(`.nss-drawer__video video`);
    videos.forEach((videoEl) => {
      videoEl.pause();
      videoEl.currentTime = 0;
    });

    if (!document.querySelector(`nss-drawer.nss-open`)) {
      document.body.classList.remove(`nss-no-scroll`);
    }

    if (this.portalEnabled) this.restoreHomeAfterTransition();
  }

  handleClick(e) {
    if (e.target.closest(`[nss-drawer-close]`)) {
      this.close();
    }
  }

  handleKeydown(e) {
    if (e.key === `Escape`) {
      this.close();
    }
  }
}

let elementName = `nss-drawer`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSDrawer);

  document.addEventListener(`click`, (e) => {
    const triggerEl = e.target.closest(`[nss-drawer-open]`);
    if (!triggerEl) return;

    const drawerId = triggerEl.getAttribute(`nss-drawer-open`);
    if (!drawerId) return;

    const drawerEl = document.querySelector(
      `nss-drawer[nss-drawer-id="${CSS.escape(drawerId)}"]`
    );
    if (!drawerEl) return;

    e.preventDefault();
    drawerEl.open();
  });
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
